import PropTypes from 'prop-types';
import { useToggle } from 'usehooks-ts';
import { Box, Button, Stack, Typography } from '@mui/material';

import { SUPPORT_EMAIL } from 'constants/common';
import { CheckboxWithLabel, Link } from 'components/simple';

const CONTENT_TEXT_PROPS = {
  variant: 'subtitle1',
  component: 'p',
};

export const FeedbackSetupConfirmation = ({ subtitle, descriptions, checkboxLabel, buttonProps, buttonLabel }) => {
  const [isChecked, toggleIsChecked] = useToggle();

  return (
    <Stack spacing={{ xs: 5, lg: 12 }}>
      <Stack spacing={5}>
        <Typography variant="h2-bold">{subtitle}</Typography>

        {descriptions.map((description) => (
          <Typography key={description} {...CONTENT_TEXT_PROPS}>
            {description}
          </Typography>
        ))}
      </Stack>

      <Stack spacing={5} alignItems={{ xs: 'stretch', sm: 'flex-start' }}>
        <CheckboxWithLabel
          label={<Typography {...CONTENT_TEXT_PROPS}>{checkboxLabel}</Typography>}
          checkboxProps={{
            onChange: toggleIsChecked,
            checked: isChecked,
          }}
        />

        <Button {...buttonProps} disabled={!isChecked}>
          {buttonLabel}
        </Button>
      </Stack>

      <Stack spacing={{ xs: 2, lg: 5 }}>
        <Typography variant="h2-bold">Any questions?</Typography>

        <Box>
          <Typography {...CONTENT_TEXT_PROPS}>
            If anything is unclear to you, or you’re not sure why you are being contacted by us, please get in touch
            with your employer for more information.
          </Typography>

          <Typography {...CONTENT_TEXT_PROPS}>
            If you have any further questions, feel free to drop us a line at{' '}
            <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
};

FeedbackSetupConfirmation.propTypes = {
  subtitle: PropTypes.string.isRequired,
  descriptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  checkboxLabel: PropTypes.string.isRequired,
  buttonProps: PropTypes.shape({
    onClick: PropTypes.func.isRequired,
    color: PropTypes.oneOf(['primary', 'success']).isRequired,
  }).isRequired,
  buttonLabel: PropTypes.string.isRequired,
};
